import { Button, Card } from "../primitives";
import Modal from "../portals/Modal";
import { useState } from "react";
import DeleteAccount from "../popup/DeleteAccount";
import Reauthenticate from "../popup/Reauthenticate";

export default function Deletion({ isReauthed, setIsReauthed }) {

    const [isOpen, setIsOpen] = useState(false)

  return (
    <>
    <Card>
        <Card.Header>
            <h2>Account Deletion</h2>
            <p>Before deleting you account, you must cancel your subscription.</p>
        </Card.Header>
        <Card.Body>
            <Button onClick={() => setIsOpen(true)} className="settings">Delete</Button>
        </Card.Body>
    </Card>
    <Modal open={isOpen} onClickOutside={() => setIsOpen(false)}>
        {isReauthed ? <DeleteAccount /> : <Reauthenticate setIsReauthed={setIsReauthed} setIsOpen={setIsOpen} />}
    </Modal>
    </>
  )
}
